export function headersWithContentType(
  headers: Record<string, string>,
): Record<string, string> {
  return { 'content-type': 'application/json', ...headers };
}
